import dayjs from 'dayjs'

import store from '@/store'
import actions from '@/store/actions'

import mutations from '../store/mutations'

export const getUsersFromGraph = async (params) => {
  try {
    const response = await store.dispatch(actions.callGraph, {
      url: 'users',
      headers: {
        ConsistencyLevel: 'eventual'
      },
      params: new URLSearchParams({
        ...params,
        $select: 'displayName,mailNickname',
        $count: true
      })
    })
    return response
  } catch (error) {
    const errorResponse = error.response ? await error.response : error
    const err = new Error('Connection error occurred')

    err.stack = error.stack
    err.response = errorResponse

    throw err
  }
}

export const getUser = async (mailNickname) => {
  const user = store.state.localUsers[mailNickname]

  if (mailNickname && !user) {
    const newUser = await getUserFromGraph(mailNickname)
    if (newUser && newUser.mailNickname) {
      store.commit(mutations.SET_LOCAL_USERS, { [newUser.mailNickname]: newUser })
    }
    return newUser
  }

  if (mailNickname && dayjs(user.lastUpdate)
    .add(process.env.VUE_APP_CACHE_EXPIRATION_DAYS, 'day')
    .isBefore(dayjs())) {
    getUserFromGraph(mailNickname).then(newUser => {
      if (newUser && newUser.mailNickname) {
        store.commit(mutations.SET_LOCAL_USERS, { [newUser.mailNickname]: newUser })
      }
    })
    return user
  }

  return user
}

export const getMultipleUsers = async (mailNicknames) => {
  if (mailNicknames.length) {
    const localUsers = Object.values(store.state.localUsers).filter(i => mailNicknames.includes(i.mailNickname))
    const missingUsers = mailNicknames.filter(i => !localUsers.find(j => (i.mailNickname || i) === j.mailNickname))
    let response = []
    if (missingUsers && missingUsers.length) {
      const query = missingUsers.reduce((acc, curr) => `${acc} mailNickname eq '${curr.mailNickname || curr}' or`, '').slice(0, -3)
      response = await getUsersFromGraph({ $filter: `${query}` })
      store.commit(mutations.SET_LOCAL_USERS, response.reduce((acc, curr) => {
        acc[curr.mailNickname] = curr
        return acc
      }, {}))
    }
    return [...localUsers, ...response]
  }
  return []
}

export const getUserFromGraph = async (mailNickname) => {
  const response = await getUsersFromGraph({ $search: `"mailNickname:${mailNickname}"` })
  return response.find(user => user.mailNickname === mailNickname)
}
